<template>
  
  <v-container fluid grid-list-lg>
    <v-layout column>
      <v-flex v-if="loading">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-flex>

      <v-flex v-else>

        <v-layout row align-center>
          <v-flex class="text-xs-center">
            <h1>Reset Your Password</h1>
          </v-flex>
        </v-layout>

        <v-layout row justify-center align-center>
          <v-flex xs12 md6 shrink style="min-height: 38px;" class="text-xs-center">
            <span>Enter your new password</span>
          </v-flex>
        </v-layout>

        <v-layout row align-center wrap my-2>
          <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
            <div class="field-label">New Password</div>
            <v-text-field
              v-model="password"
              type="password"
              solo
              flat
              hide-details
              :disabled="resetting"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
            <div class="field-label">Verify Password</div>
            <v-text-field
              v-model="passwordVerify"
              type="password"
              solo
              flat
              hide-details
              @keydown="checkKeyup"
              :disabled="resetting"
            ></v-text-field>
          </v-flex>
          
          <v-flex xs12 mb-2 mt-4 class="text-xs-center">
            <v-btn color="primary" @click="resetPassword" style="min-width: 150px;" :loading="resetting">RESET</v-btn>
          </v-flex>
          
        </v-layout>

        <v-layout row>
          <v-flex xs12 class="text-xs-center">
            <span class="body-1"><router-link :to="{name: 'auth'}">Back to Login</router-link></span>
          </v-flex>
        </v-layout>


      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>

export default {
  name: 'ResetPassword',
  data () {
    return {
      loading: true,
      resetting: false,
      password: null,
      passwordVerify: null
    }
  },
  mounted: function() {
    this.getDataFromApi();
  },
  computed: {
    token: function() {
      return this.$route.params.token;
    }
  },
  methods: {
    getDataFromApi: function() {
      let params = {
        token: this.token
      };

      this.$http.post('auth/check', params)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.$swal.fire('Error', 'Invalid password reset token');
          this.$router.replace({name: 'auth'});
        });
    },
    resetPassword: function() {
      if(!this.password) {
        this.$swal.fire('Password Required', 'You must enter a new password');
        return;
      }
      if(this.password !== this.passwordVerify) {
        this.$swal.fire('Password Don\'t Match', 'Your passwords don\'t match');
        return;
      }

      this.resetting = true;
      
      this.$http.post('auth/reset-password', {
        new_pass: this.password,
        new_pass_conf: this.passwordVerify,
        token: this.token
      })
        .then(response => {
          this.$store.commit('updateAccessToken', response.data.access_token);
          delete(response.data.access_token);
          this.$store.commit('setUser', response.data);
          this.$router.push({name: 'account-trips'});
          this.$store.dispatch('checkForUpdates');
        })
        .catch(error => {
          this.$swal.fire('Error', error.response.data.message);
        })
        .finally( () => {
          this.resetting = false;
        })
    },
    checkKeyup: function(e) {
      if(e.key == 'Enter') this.resetPassword();
    }
  }
}
</script>
